import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import router from '@/router';
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabbarIndex',
  setup(__props) {

const menusList = ref([
  {
    name: '首页',
    path: '/',
    icons: require('@/assets/images/shouyeimg.png'),
    activeIcons: require('@/assets/images/shouyeimg_1.png')
  },
  {
    name: '找大厅',
    path: '/findTheLobby',
    icons: require('@/assets/images/zhaodatingimg.png'),
    activeIcons: require('@/assets/images/zhaodatingimg_1.png')
  },
  {
    name: '找服务',
    path: '/findServices',
    icons: require('@/assets/images/zhaofuwuimg.png'),
    activeIcons: require('@/assets/images/zhaofuwuimg_1.png')
  },
  {
    name: '我的',
    path: '/my',
    icons: require('@/assets/images/wodeimg.png'),
    activeIcons: require('@/assets/images/wodeimg_1.png')
  }
])
const showTabbar = ref(false);
const active = ref(0);
const routers = useRoute()
const routerList = ref(['/', '/findTheLobby', '/findServices', '/my'])
watch(() => routers.path, (newValue) => {
  if (routerList.value.includes(newValue)) {
      showTabbar.value = true;
    } else {
      showTabbar.value = false;
    }
    if (newValue === '/') {
      active.value = 0
    } else if (newValue === '/findTheLobby') {
      active.value = 1
    } else if (newValue === '/findServices') {
      active.value = 2
    } else if (newValue === '/my') {
      active.value = 3
    }
}, { immediate: true })

const goToRouters = (index: number) => {
  if (index === 0) {
    router.push({
      path: '/'
    })
  }
  if (index === 1) {
    router.push({
      path: '/findTheLobby'
    })
  }
  if (index === 2) {
    router.push({
      path: '/findServices'
    })
  }
  if (index === 3) {
    router.push({
      path: '/my'
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (showTabbar.value)
    ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 0,
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        placeholder: true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menusList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tabbar_item, {
              key: index,
              onClick: ($event: any) => (goToRouters(index))
            }, {
              icon: _withCtx((props) => [
                _createElementVNode("img", {
                  src: props.active ? item.activeIcons : item.icons
                }, null, 8, _hoisted_1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})